import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { servicesAPI } from '../lib/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { formatPrice } from '../lib/utils';

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    loadServices();
  }, [selectedCategory]);

  const loadServices = async () => {
    try {
      const response = await servicesAPI.getAll(selectedCategory);
      setServices(response.data);
    } catch (error) {
      console.error('Failed to load services', error);
    } finally {
      setLoading(false);
    }
  };

  const categories = [
    { value: null, label: 'All Services' },
    { value: 'google_ads', label: 'Google Ads' },
    { value: 'meta_ads', label: 'Meta Ads' },
    { value: 'wordpress_support', label: 'WordPress Support' },
    { value: 'hosting', label: 'Hosting' },
    { value: 'newsletter', label: 'Newsletter' },
    { value: 'accessibility', label: 'Accessibility' },
    { value: 'email_client', label: 'Email Client' },
  ];

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-heading font-bold mb-2">Our Services</h1>
          <p className="text-muted-foreground">Browse and purchase our professional services</p>
        </div>

        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => (
            <Button
              key={cat.value || 'all'}
              variant={selectedCategory === cat.value ? 'default' : 'outline'}
              onClick={() => setSelectedCategory(cat.value)}
              data-testid={`category-${cat.value || 'all'}`}
            >
              {cat.label}
            </Button>
          ))}
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service) => (
              <Card key={service.id} className="hover:shadow-lg transition-shadow" data-testid={`service-${service.id}`}>
                {service.image_url && (
                  <img src={service.image_url} alt={service.name} className="w-full h-48 object-cover rounded-t-xl" />
                )}
                <CardHeader>
                  <CardTitle className="line-clamp-2">{service.name}</CardTitle>
                  <CardDescription className="line-clamp-2">{service.short_description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-sm text-muted-foreground">Starting from</span>
                    <span className="text-xl font-bold text-primary">
                      {formatPrice(Math.min(...(service.pricing_tiers || []).map(t => t.price)))}
                    </span>
                  </div>
                  <Link to={`/my-catalog/${service.id}`}>
                    <Button className="w-full" data-testid={`view-service-${service.id}`}>
                      View Details
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
